import React from 'react'


import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import BrandFilterBar from "../../components/common/BrandFilterBar/BrandFilterBar";
import Breadcrumbs from "../../components/common/Breadcrumbs/Breadcrumbs";
import Footer from "../../components/common/Footer/Footer";
import { useToast } from "../../hooks/useToast";
import { getMyBrandBusinessDetailForAgency } from '../../store/agencyStore/actions/getMyBrandBusinessDetailForAgencyActions';
import {

} from 'react-icons/fi';


// get bg color of active and inactive
const getStatusStyle = (status) => {
    switch (status.toLowerCase()) {
        case 'active':
            return 'bg-[#0D9B50] text-[#FFFFFF]';
        case 'inactive':
            return 'bg-[#FF0505] text-[#FFFFFF]';
        default:
            return 'bg-[#FCBE2D] text-[#FFFFFF]';
    }
};

// New Campaign Card component for mobile view
const CampaignCard = ({ campaign, onViewDetails }) => (
    <div className="bg-white rounded-lg shadow-md p-4 mb-4 border border-gray-300">
        <div className="flex flex-col space-y-3">

            <div className="flex items-center">
                <span className="text-[1.4rem] font-semibold text-gray-500 w-32">Brand Name:</span>
                <span className="text-[1.4rem]">{campaign.name}</span>
            </div>

            <div className="flex items-center">
                <span className="text-[1.4rem] font-semibold text-gray-500 w-32">Phone Number:</span>
                <span className="text-[1.4rem]">{campaign.phone}</span>
            </div>


            <div className="flex items-center">
                <span className="text-[1.4rem] font-semibold text-gray-500 w-32">Website:</span>
                <a href={campaign.website} target="_blank" className="text-[1.4rem]">{campaign.website}</a>
            </div>

            <div className="flex items-center">
                <span className="text-[1.4rem] font-semibold text-gray-500 w-32">Address:</span>
                <span className={`text-[1.4rem] px-2 py-1 rounded-full multiline`}>
                    {campaign.address}
                </span>
            </div>

        </div>
    </div>
);

const AgencyBrandListPage = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const Toast = useToast();

    const [isMobile, setIsMobile] = useState(false);
    const [filteredBrands, setFilteredBrands] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [sorted, setSorted] = useState('');

    const getMyBrandBusinessDetailForAgencyReducerData = useSelector((state) => state.getMyBrandBusinessDetailForAgencyReducer.data);
    const getUserInfoReducerData = useSelector((state) => state.getUserInfoReducer.data);

    const customTableStyles = {
        table: {
            style: {
                position: 'relative',
            },
        },
        headRow: {
            style: {
                backgroundColor: '#F1F4F9',
                minHeight: '52px',
                fontWeight: 700,
                borderRadius: '0.4rem',
                borderBottom: 'none',
                // position: 'fixed',
                top: 0,
            },
            denseStyle: {
                minHeight: '32px',
            },
        },
        rows: {
            style: {
                fontSize: '1.4rem',  // Increased text size for rows
                fontWeight: 600,
                color: '#202224',
                borderBottom: '1px solid #EDEFF1',
                minHeight: '70px',
            },
            denseStyle: {
                minHeight: '40px',
            },
        },
        headCells: {
            style: {
                padding: '1rem',
                fontSize: '1.6rem',
                textAlign: 'left',
            },
        },
        cells: {
            style: {
                padding: '1.5rem',
            },
        },
    };

    const columns = [
        {
            name: 'Brand Name',
            selector: row => row.name,
            sortable: true,
            style: {
                width: '10rem',  // Set a smaller width for this column
            },
            wrap: true,
        },
        {
            name: 'Phone Number',
            selector: row => row.phone,
            style: {
                width: '10rem',  // Adjust the width for consistency
            },
        },
        {
            name: 'Website',
            selector: row => row.website,
            sortable: true,
            style: {
                width: '10rem',  // Adjust the width as needed
            },
        },
        {
            name: 'Address',
            selector: row => row.address,
            style: {
                width: '10rem',  // Set a smaller width for this column
            },
            wrap: true,
        }
    ];

    const handleFilter = (role) => {
        dispatch(getMyBrandBusinessDetailForAgency({}, (status, response, message) => {
            if (status === 200) {
                setFilteredBrands(response);
            } else {
                setFilteredBrands([]);
            }
        }));
    };

    const handleReset = () => {
        dispatch(getMyBrandBusinessDetailForAgency({}, (status, response, message) => {
            if (status === 200) {
                setFilteredBrands(response);
            } else {
                setFilteredBrands([]);
            }
        }));
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    // Check if the screen is mobile size
    useEffect(() => {
        const checkIfMobile = () => {
            setIsMobile(window.innerWidth < 768); // 768px is typical tablet breakpoint
        };

        // Set initial value
        checkIfMobile();

        // Add event listener for window resize
        window.addEventListener('resize', checkIfMobile);

        // Clean up
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);

    useEffect(() => {
        dispatch(getMyBrandBusinessDetailForAgency({}, (status, response, message) => {
            if (status === 200) {
                console.log("response", response);
            } else {
                console.log("message", message);
            }
        }));
    }, []);

    useEffect(() => {
        if (Array.isArray(getMyBrandBusinessDetailForAgencyReducerData) && getMyBrandBusinessDetailForAgencyReducerData.length > 0) {
            setSorted(getMyBrandBusinessDetailForAgencyReducerData);
            setFilteredBrands(getMyBrandBusinessDetailForAgencyReducerData);
        } else {
            setFilteredBrands([]);
        }
    }, [getMyBrandBusinessDetailForAgencyReducerData]);

    useEffect(() => {
        if (searchQuery === '') {
            setFilteredBrands(sorted);
        } else if (Array.isArray(sorted) && sorted.length > 0) {

            const filtered = sorted.filter(brand =>
                brand.name.toLowerCase().includes(searchQuery.toLowerCase())
            );
            setFilteredBrands(filtered);
        }
    }, [searchQuery, sorted]);

    return (
        <div className="w-full h-full flex flex-col justify-start bg-[#F2F3F7] ">
            <Breadcrumbs breadcrumbs={[{ label: 'Home', href: '/' }, { label: 'Brand Management', href: '/agency/brand-management' }]} />
            <div className="w-full flex justify-between items-center my-[0.5rem] px-[4rem] h-[9rem]">
                <div className="relative">
                    <input
                        type="text"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        placeholder="Search Brands"
                        className="w-[20rem] p-3 border text-[1.4rem] inter-font  font-[400] border-gray-300 rounded-[0.3rem] outline-none"
                    />
                </div>
                <div className="flex space-x-[1.2rem]">
                    {getUserInfoReducerData?.agencyRoleName !== "Viewer" &&
                        <button
                            className="flex items-center bg-[#0D9B50] rounded-lg text-[1.6rem] text-white px-4 py-2"
                            onClick={() => {
                                navigate('/agency/brand-management/create-brand');
                            }}
                        >
                            <h1 className="inter-font font-[500] px-4 py-2">Create New Brand</h1>
                        </button>
                    }
                </div>
            </div>

            {/* <div className='w-full h-[12rem] flex flex-col px-[4rem]'>
                <BrandFilterBar
                    onFilter={handleFilter}
                    onReset={handleReset}
                />
            </div> */}
            <div className="w-full h-full flex flex-col px-[4rem]">
                <div className="w-full flex flex-col rounded-[2.6rem] bg-[#ffffff]">
                    {/* Sticky Header Section */}
                    <div className="sticky top-0 z-10 bg-[#ffffff] mb-1 p-[3.2rem]">
                        <h1 className="text-[2.4rem] text-[#202224] inter-font font-[700]">
                            Brand Management
                        </h1>
                    </div>

                    {/* Table Container or Card Container based on screen size */}
                    <div className="w-full max-h-[50rem] overflow-y-auto no-scrollbar px-[2.4rem] pb-[2.4rem]">
                        {Array.isArray(filteredBrands) && filteredBrands.length > 0 ? (
                            isMobile ? (
                                // Mobile view - Cards
                                <div className="flex flex-col space-y-4">
                                    {filteredBrands.map((brand, index) => (
                                        <CampaignCard
                                            key={index}
                                            campaign={brand}
                                            onViewDetails={() => { }}
                                        />
                                    ))}
                                </div>
                            ) : (
                                // Desktop view - Table
                                <DataTable
                                    columns={columns}
                                    data={filteredBrands}
                                    customStyles={customTableStyles}
                                    pagination
                                    highlightOnHover
                                    responsive
                                />
                            )
                        ) : (
                            <div className="text-2xl md:text-4xl leading-[50px] md:leading-[70px] text-gray-500 text-center mt-4">
                                There are no records to display.
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default AgencyBrandListPage